import React, { useEffect, useState } from "react";
import api from "utils/apiService";
import { useSearchParams } from "react-router-dom";
import CheckTable from "components/CheckTable";
import SubscribersColumn from "data/SubscribersColumn";

const Subscribers = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const role = searchParams.get("role") || "";
  const status = searchParams.get("status") || "";

  const fetchData = async () => {
    setLoading(true);
    let url = `/subscriptions/subscribers?page=${page}&limit=20`;
    if (role) url += `&role=${role}`;
    if (status) url += `&status=${status}`;
    const res = await api.get(url);
    if (!res.error) {
      setData({
        data: res.data || [],
        pagination: {
          totalDocs:
            (res.pagination && res.pagination.total) || (res.data || []).length,
        },
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [page, role, status]);

  return (
    <section className="mt-3">
      <CheckTable
        columnsData={SubscribersColumn()}
        tableData={data.data}
        title="المشتركون"
        loading={loading}
        totalCount={data.pagination.totalDocs}
      />
    </section>
  );
};

export default Subscribers;
